module.exports = __webpack_public_path__ + "static/media/_Placering.2c87b41b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/Fair/_Placering.scss
// module id = 548
// module chunks = 0